import { loc } from "../../../../../core/utils"
import { number, string } from "prop-types"
import React from "react"
import { Col, Row } from "react-bootstrap"

export default function DeliveryCharge({ deliveryCharges, price }) {
  return (
    <li>
      <Row>
        <Col>
          <p>{loc`Shipping fees`}</p>
        </Col>
        {deliveryCharges > 0 && (
          <Col>
            <p className="text-right">{price}</p>
          </Col>
        )}
        {!deliveryCharges && (
          <Col>
            <p className="text-right">{loc`Included`}</p>
          </Col>
        )}
      </Row>
    </li>
  )
}

DeliveryCharge.propTypes = {
  deliveryCharges: number,
  price: string
}
